import React from 'react';
import AnantTradeCenter from './AnantTradeCenter';

export default function AtcB2C() {
  return <AnantTradeCenter dealType="B2C_RETAIL" />;
}
